export default "__VITE_ASSET__b189845f__"